function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Drag Drop");

var SvgDragdrop = function SvgDragdrop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("path", {
    d: "M49.85,50.57a.29.29,0,0,0-.21.09.27.27,0,0,0-.1.22.28.28,0,0,0,.1.22.29.29,0,0,0,.21.09.29.29,0,0,0,.22-.09.31.31,0,0,0,.09-.22.31.31,0,0,0-.31-.31Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M51.09,50.57a.31.31,0,0,0-.22.09.29.29,0,0,0-.09.22.31.31,0,0,0,.31.31.33.33,0,0,0,.22-.09.31.31,0,0,0,.09-.22.29.29,0,0,0-.09-.22A.33.33,0,0,0,51.09,50.57Z",
    style: {
      fill: "#ccc"
    }
  }), React.createElement("path", {
    d: "M83.24,37.84H12.76a1.71,1.71,0,0,0-1.7,1.7V56.46a1.71,1.71,0,0,0,1.7,1.7H83.24a1.71,1.71,0,0,0,1.7-1.7V39.54A1.71,1.71,0,0,0,83.24,37.84Zm-37.62,8.5,2.16-2.16a.29.29,0,0,1,.44,0l2.16,2.16a.27.27,0,0,1,.07.33.29.29,0,0,1-.29.19H48.93V49a.29.29,0,0,1-.09.21.33.33,0,0,1-.22.09H47.38a.29.29,0,0,1-.21-.09.26.26,0,0,1-.1-.21V46.86H45.84a.29.29,0,0,1-.29-.19A.27.27,0,0,1,45.62,46.34Zm6.4,5a.48.48,0,0,1-.47.47h-7.1a.48.48,0,0,1-.47-.47V49.8a.48.48,0,0,1,.47-.47h2.06a1,1,0,0,0,.34.45.93.93,0,0,0,.53.17h1.24a.93.93,0,0,0,.53-.17,1,1,0,0,0,.34-.45h2.06a.48.48,0,0,1,.47.47Z",
    style: {
      fill: "#ccc"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDragdrop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DRAGDROP.892b7bfc.svg";
export { ForwardRef as ReactComponent };